import { getCountry } from '../modules/i18n';

document.addEventListener('jb-e-service-overlay:connected', async (event: Event) => {
  const { element } = (event as CustomEvent).detail;
  element.preselectedCountry = await getCountry();
});
